// Gouvernance — Tickets OH (total / actifs / bloqués).
import { Ticket } from "lucide-react";
import { useGovernanceData } from "./useGovernanceFetch";

export default function GouvTicketsWidget() {
  const { data, loading } = useGovernanceData();
  const tickets = data.tickets;

  return (
    <div className="p-5 rounded-xl bg-zinc-900/50 border border-zinc-800" data-testid="gouv-tickets-widget">
      <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
        <Ticket className="w-5 h-5 text-blue-400" />
        Tickets OH
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        <Stat label="Total" value={tickets?.total || 0} bg="bg-zinc-800/50" color="text-white" loading={loading} />
        <Stat label="Actifs" value={tickets?.active || 0} bg="bg-blue-500/10" color="text-blue-400" loading={loading} />
        <Stat label="Bloqués" value={tickets?.blocked || 0} bg="bg-red-500/10" color="text-red-400" loading={loading} />
      </div>
    </div>
  );
}

function Stat({ label, value, bg, color, loading }) {
  return (
    <div className={`text-center p-3 rounded-lg ${bg}`}>
      <div className={`text-2xl font-bold ${color}`}>{loading ? "…" : value}</div>
      <p className="text-xs text-zinc-500">{label}</p>
    </div>
  );
}
